import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import { t } from '@/i18n';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.challenges_details.breadcrumb.label_1')?.toUpperCase(),
    link: '/application',
  },

  {
    label: t('pages.challenges_details.breadcrumb.label_2')?.toUpperCase(),
    link: '/application/challenge',
  },

  {
    label: t('pages.challenges_details.breadcrumb.label_3')?.toUpperCase(),
  },
];
